module.exports = __webpack_public_path__ + "img/cuff width.001e2335.png";